import * as React from 'react';

import { CompactNumber } from '@blockworks/ui/number';
import { cn } from '@blockworks/ui/utils';

import MarketDataCard from '@/components/display/cards/market-data-card';
import SectionHeader from '@/components/display/headers/section-header';

type PriceMarketDataProps = {
    usd24hChange: number;
    usd24hVolume: number;
    usdMarketCap: number;
    circulatingSupply: number;
    marketCapRank: number;
    className?: string;
};

const PriceMarketData = (props: PriceMarketDataProps) => {
    const { usd24hChange, usdMarketCap, usd24hVolume, circulatingSupply, marketCapRank, className } = props;

    return (
        <section className={cn('flex flex-col lg:border-b lg:border-none', className)}>
            <SectionHeader
                title="market data"
                linkTitle=""
                className="border-t border-b h-[60px] gap-3 px-6 lg:px-10 py-5"
            />
            <div
                className="flex flex-wrap lg:flex-col justify-start gap-5 p-10 border-t-0 border-r-0 border-l-0"
                itemScope
            >
                <div className="flex flex-col relative gap-2">
                    <MarketDataCard title="Market Cap" className="flex" movePercentage={usd24hChange}>
                        <span>
                            $ <CompactNumber number={usdMarketCap} fractionDigits={2} />
                        </span>
                    </MarketDataCard>
                </div>
                <div className="flex flex-col relative gap-2">
                    <MarketDataCard title="Market Cap Rank">
                        <span>#{marketCapRank}</span>
                    </MarketDataCard>
                </div>
                <div className="flex flex-col relative gap-2">
                    <MarketDataCard title="24H Volume">
                        <span>
                            $ <CompactNumber number={usd24hVolume} fractionDigits={2} />
                        </span>
                    </MarketDataCard>
                </div>
                <div className="flex flex-col relative gap-2">
                    <MarketDataCard title="Circulating Supply">
                        <span>
                            {new Intl.NumberFormat('en-US', { maximumSignificantDigits: 2 }).format(circulatingSupply)}
                        </span>
                    </MarketDataCard>
                </div>
            </div>
        </section>
    );
};

export default PriceMarketData;
